import React from 'react';
import GeneralModal from '../../../../components/UI/modal/GeneralModal';
import useTags from '../../../../hooks/useTags';
import cancelPermitModalLang from '../../../../data/lang/homePage/cancelPermitModal.lang';
import { useIsOpenCancelPermitModalData, useCloseCancelPermitModalData } from '../../../../stores/permitIsCanceledModal.store';
import ExistBtn from '../../../../components/buttons/ExistBtn';


const CancelPermitModal = () => {

    const iModalOpen = useIsOpenCancelPermitModalData();
    const closeCancelPermitModal = useCloseCancelPermitModalData();
    const generateTag = useTags();

    const modalTitleTag = generateTag(cancelPermitModalLang, 'modal-title');
    const cancellationMessageTag = generateTag(cancelPermitModalLang, 'cancellation-message');


    return (
        <GeneralModal
            show={iModalOpen}
            closingFunc={closeCancelPermitModal}
            title={modalTitleTag}
            modalSize='S'
            body={(
                <div className='p-4 fs-3 text-center'>
                    {cancellationMessageTag}
                </div>
            )}
            footer={(
                <ExistBtn onClick={closeCancelPermitModal} />
            )}
        />
    );
}

export default CancelPermitModal;